import React from 'react';

import { Flex } from '../flex';
import { FlexItem } from '../flex-item';
import { Container, Description, InputArea, Label } from './styled';
import type { SettingWrapperProps } from './types';

export const SettingWrapper: React.FC<SettingWrapperProps> = ({
  label,
  description,
  children,
  className,
  testId,
  styleProps,
  disabled = false,
  htmlId,
}) => {

  const uniqueId = htmlId || `setting-${label.toLowerCase().replace(/\s+/g, '-')}`;

  return (
    <Container
      className={className}
      data-testid={testId}
      $styleProps={styleProps}
      $disabled={disabled}
    >
      <Flex>
        <FlexItem flex='0 0 210px'>
          <Label htmlFor={uniqueId} $styleProps={styleProps} $disabled={disabled}>
            {label}
          </Label>
        </FlexItem>
        <FlexItem flex='1 1 auto'>
          <InputArea $styleProps={styleProps} $disabled={disabled}>
            {}
            {React.Children.map(children, (child) => {
              if (React.isValidElement(child)) {

                return React.cloneElement(child, {
                  id: uniqueId,
                  disabled: disabled || child.props.disabled,
                  ...child.props,
                });
              }
              return child;
            })}
          </InputArea>
          {description && (
            <Description $styleProps={styleProps} $disabled={disabled}>
              {description}
            </Description>
          )}
        </FlexItem>
      </Flex>
    </Container>
  );
};